<template>
  <div class="joinTheProgram-body">
    <div class="title">
      <span>{{ highlightText }}</span> {{ mainText }}
    </div>
    <a
      href="mailto:info@wecobi.com?subject=General Inquiry&body=I would like to know more about your company."
      class="button"
      >Contact Us</a
    >
  </div>
</template>

<script>
export default {
  name: "JoinTheProgram",
  props: {
    highlightText: {
      type: String,
      required: true,
    },
    mainText: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.joinTheProgram-body {
  width: 100%;
  height: fit-content;
  background-color: #f7f7fa;
  border-radius: 20px;
  padding: 80px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 26px;
}
.title {
  font-size: 22px;
  font-weight: 400;
  line-height: 1.5;
  max-width: 1100px;
  text-align: center;
}
span {
  font-weight: 700;
}
.button {
  width: 151px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 17px;
  font-weight: 600;
  border-radius: 30px;
  border: 2px solid #000000;
  color: #000000;
  background-color: #f7f7fa;
}
.button:hover {
  color: #ffffff;
  border: 2px solid #000000;
  background-color: #000000;
}

@media (max-width: 1280px) {
  .title {
    font-size: 18px;
    max-width: 836px;
  }
}
@media (max-width: 1280px) {
  .title {
    max-width: 580px;
  }
}
@media (max-width: 1024px) {
  .title {
    max-width: 580px;
  }
}

@media (max-width: 744px) {
  .title {
    max-width: 551px;
  }
}
@media (max-width: 588px) {
  .title {
    max-width: 395px;
  }
}
@media (max-width: 319px) {
  .joinTheProgram-body {
    padding: 100px 0px;
  }
  .title {
    max-width: 318px;
  }
}
</style>
